module.exports = __webpack_public_path__ + "static/media/4.255e6aca.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/perks/4.png
// module id = 60
// module chunks = 0